import { useCallback, useState } from 'react';

import { IRenderCallback } from '../types/IRenderCallback';

export interface IIsRenderedCallback<TType> {
    (element: TType): void;
}

export function useIsRendered<TType> (onRender?: IIsRenderedCallback<TType>): [boolean, TType | undefined, IRenderCallback<TType | null>] {
    const [isRendered, setIsRendered] = useState(false);
    const [element, setElement] = useState<TType | undefined>(undefined);

    const onBoxRender: IRenderCallback<TType | null> = useCallback((element: TType | null): void => {
        if (element === null) {
            return;
        }

        setIsRendered(true);
        setElement(element);

        if (onRender) {
            onRender(element);
        }
    }, [onRender]);

    return [isRendered, element, onBoxRender];
}
